module.exports = __webpack_public_path__ + "static/cuk-43b616fb80d9db705eefb54a052b2952.jpg";